module.exports = __webpack_public_path__ + "img/list_12_zh.3a8461fd.png";